<div *ngIf="policies?.length >= 1">
<div class="row text-center" *ngIf="displayIDCardHeader">
  <div class="col">
    <div class="header-icon margin-bottom mb8">
      <img src="./assets/img/images/icon-id-card-acmic-64.svg" alt="ID Card Icon">
    </div>
    <ng-container *ngIf="(policies?.length > 1 ) || (policies?.length === 1 && vehicles?.length > 1);else singleCard">
      <h1 class="title-copy font-weight-normal id-card-title">{{ "ID Cards" | translate }}</h1>      
      <div class="id-card-desc">
        <ng-container *ngIf="(policies?.length === 1 && vehicles?.length > 1); else selectOnlyVehicleText">
          {{"Select your vehicle(s) to view or download proof of insurance ID Cards. ID Cards will display the primary policyholder and the vehicle(s) selected:" | translate }}
        </ng-container>
        <ng-template #selectOnlyVehicleText>
          <span class="id-cards-desc-multiple">
            {{ "Select your policy and vehicle(s) to view or download proof of insurance ID Cards. ID Cards will display the primary policyholder and the vehicle(s) selected:" | translate }}
          </span>
        </ng-template>
      </div>
    </ng-container>
    <ng-template #singleCard>
      <h1 class="title-copy font-weight-normal id-card-title">{{ "ID Card" | translate }}</h1>
      <div class="id-card-desc">{{ "Proof of insurance ID Cards will display the policyholders and the vehicle listed on the policy." | translate }}</div>
    </ng-template>            
  </div>
</div>
<div class="id-cards-sec" [ngClass]="{ 'id-cards-sec-dashboard w-100-percent margin-left ml0': navFrom === 'dashboard' }">
  <form [formGroup]="idCardForm">
    <div *ngIf="!isPolicyExists && policies?.length > 1">
      <div class="mb-4">
        <label for="select-policy" class="multi-select-lable">{{ "CHOOSE_POLICY" | translate }}</label>
        <div class="w-100 choose-policy-select pb-0">
            <ng-select 
                [items]="policyMap" 
                bindLabel="name" 
                [autofocus]="false" 
                bindValue="name" 
                [searchable]="false" 
                [multiple]="false"
                [clearable]="false" 
                [markFirst]="false" 
                placeholder="Select" 
                fixedPlaceholder="true"
                [dropdownPosition]="'bottom'"
                [formControlName]="'selectedPolicy'"
                (click)="onPOlicySelect(name)"> 
                <ng-template ng-label-tmp let-item="item">
                    <div class="dropdown-item-container">
                      
                      <div><ng-container *ngIf="item.name.includes('Auto') || item.name.includes('Property')">Personal</ng-container>
                         {{item.name | lowercase | translate | replaceUnderscoreWithSpace}}</div>
                    </div>
                </ng-template>
                <ng-template
                        ng-option-tmp
                        let-item="item"
                        let-index="index">
                        <div class="dropdown-item-container">
                            <div><ng-container *ngIf="item.name.includes('Auto') || item.name.includes('Property')">Personal</ng-container>
                               {{item.name | lowercase|translate | replaceUnderscoreWithSpace}}</div>
                        </div>
                </ng-template>
            </ng-select>
        </div>
      </div>
    </div>
    <div *ngIf="(policies?.length > 1 ) || (policies?.length === 1 && vehicles?.length > 1)">
      <div class="multi-select-lable">{{'Choose vehicle(s)' | translate }}</div>
      <ng-select 
                  #select
                  [items]="vehicles"
                  bindLabel="name"
                  placeholder="Select"
                  [multiple]="true"
                  [closeOnSelect]="false"
                  [clearable]="false"
                  clearAllText="Clear"
                  formControlName="selectedItems"
                  dropdownPosition="bottom"
                  (click)="onSelectOpen(policyId)"
                  (close)="onSelectionClose()"
                  [isOpen]="currentPolicy?.isOpen"
      >
      <ng-template ng-multi-label-tmp>
        <span style="display:block" class="ng-placeholder">Select</span>
      </ng-template>
      <ng-template ng-header-tmp>
        <div class="id-card-select">Select</div>
        <a *ngIf="vehicles.length > 1" (click)="selectAll()" class="mapfre link underline selectAll-color">Select all</a>
      </ng-template>
      <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">          
          <div class="checkbox" >
            <input
                *ngIf="vehicles.length > 1"
                class="single-checkbox"
                type="checkbox"
                id="item-{{index}}"
                [ngModel]="item$.selected"
                [ngModelOptions]="{standalone: true}"
                >
              <label class="id-card-select-label lh-19-acmic" [ngClass]="{'form-check-label':vehicles.length > 1}" for="id-card-checkbox">{{item['name']}}</label>            
          </div>
        </ng-template>
      </ng-select>
      <div *ngIf="policySelected && !idCardForm?.value?.selectedItems?.length" class="id-card-error">Selection is required</div>
    </div>    
  </form>
</div>
<div class="id-card-actions" 
      [ngStyle]="{'margin-top':currentPolicy?.heightOfSelctOptions}" 
      [ngClass]="{ 'mobile-flex-col': navFrom === 'dashboard'}">
      
  <mapfre-button  
      [disabledValue]="(idCardForm?.value?.selectedItems?.length) || (policies?.length === 1 && vehicles?.length <= 1)" 
      [inputType]="'submit'"
      [translateValue]="'View' | translate" [additionalClasses]="'view-id-card'"
      (click)="viewIdCard()">
  </mapfre-button>
  <div class="w-100-mobile">
    <mapfre-button  
        [disabledValue]="(idCardForm?.value?.selectedItems?.length) || (policies?.length === 1 && vehicles?.length <= 1)" 
        [inputType]="'submit'"
        [translateValue]="'DOWNLOAD' | translate" [additionalClasses]="'download-btn id-download-btn'"
        (click)="downloadIdCard()">
    </mapfre-button>
  </div>
</div>
</div>
